import { takeLatest, call, put } from "redux-saga/effects"
import axios from "axios"
import { message } from "antd"

import { push } from "connected-react-router"
import {
  GET_COLLABORATORS_SUMMARY_WATCHER,
  UPLOAD_TEMPLATE_COLLABORATORS_WATCHER,
  SAVE_EXCEL_COLLABORATORS_WATCHER,
  GET_CEASED_SUMMARY_WATCHER,
  UPLOAD_TEMPLATE_CEASED_WATCHER,
  SAVE_EXCEL_CEASED_WATCHER,
  GET_DIVISIONS_ASSIGNMENT_SUMMARY_WATCHER,
  SAVE_EXCEL_DIVISIONS_ASSIGNMENT_WATCHER,
  UPLOAD_TEMPLATE_DIVISIONS_ASSIGNMENT_WATCHER,
  GET_TEAMS_SUMMARY_WATCHER,
  SAVE_EXCEL_TEAMS_WATCHER,
  UPLOAD_TEMPLATE_TEAMS_WATCHER,
} from "./constants"
import {
  getCollaboratorsSummarySuccess,
  getCollaboratorsSummaryFailed,
  uploadTemplateCollaboratorsFailed,
  uploadTemplateCollaboratorsSuccess,
  saveExcelCollaboratorsProgress,
  saveExcelCollaboratorsSuccess,
  saveExcelCollaboratorsFailed,
  getCeasedSummarySuccess,
  getCeasedSummaryFailed,
  uploadTemplateCeasedSuccess,
  uploadTemplateCeasedFailed,
  saveCollaboratorsCeasedProgress,
  saveCollaboratorsCeasedSuccess,
  getDivisionsAssignmentSummarySuccess,
  getDivisionsAssignmentSummaryFailed,
  saveExcelDivisionsAssignmentProgress,
  saveExcelDivisionsAssignmentSuccess,
  uploadTemplateDivisionsAssignmentSuccess,
  uploadTemplateDivisionsAssignmentFailed,
  getTeamsSummarySuccess,
  getTeamsSummaryFailed,
  saveTeamsSuccess,
  saveTeamsProgress,
  uploadTemplateTeamsSuccess,
  uploadTemplateTeamsFailed,
} from "./actions"
import { importCollaboratorSegment } from "../../utils/segment/Employee/employeeTrack"
import {
  KEY_TIMESTAMP_COLLABORATORS_IMPORT,
  LOCAL_COMPANY_ID,
  LOCAL_TIMESTAMP_COLLABORATORS_IMPORT,
  LOCAL_TOKEN,
  setItem,
} from "../../utils/storage"

function messageProgress(messagex) {
  message.loading(messagex, 0)
}

function messageSuccess(messagex) {
  message.success(messagex, 5)
}

function messageFailed(messagex) {
  message.error(messagex, 5)
}

function messageDestroy() {
  message.destroy()
}

// GET SUMMARY
function getCollaboratorsSummaryApi() {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/employees/import/xlsx/summary`,
    params: {
      timestamp: LOCAL_TIMESTAMP_COLLABORATORS_IMPORT(),
    },
  })
}

function getDivisionsAssignmentSummaryApi() {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/employees/divisions-assignment/import/xlsx/summary`,
    params: {
      timestamp: LOCAL_TIMESTAMP_COLLABORATORS_IMPORT(),
    },
  })
}

function* getCollaboratorsSummary(action) {
  try {
    const { data, status } = yield call(getCollaboratorsSummaryApi)

    if (status === 200) {
      yield put(getCollaboratorsSummarySuccess(data))
    }
  } catch (error) {
    yield put(getCollaboratorsSummaryFailed())
    yield put(push("/organization#collaborators"))
  }
}


function* getDivisionsAssignmentSummary(action) {
  try {
    const { data, status } = yield call(getDivisionsAssignmentSummaryApi)

    if (status === 200) {
      yield put(getDivisionsAssignmentSummarySuccess(data))
    }
  } catch (error) {
    yield put(getDivisionsAssignmentSummaryFailed())
  }
}
// GET SUMMARY
function getTeamsSummaryApi() {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/teams/import/xlsx/summary`,
    params: {
      timestamp: LOCAL_TIMESTAMP_COLLABORATORS_IMPORT(),
    },
  })
}

function* getTeamsSummary(action) {
  try {
    const { data, status } = yield call(getTeamsSummaryApi)

    if (status === 200) {
      yield put(getTeamsSummarySuccess(data))
    }
  } catch (error) {
    console.log(error)
    yield put(getTeamsSummaryFailed())
    yield put(push("/organization#collaborators"))
  }
}

// UPLOAD EXCEL
function uploadTemplateCollaborators(payload) {
  return axios.request({
    method: "post",
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/employees/import/xlsx`,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    data: payload,
  })
}

function uploadTemplateDivisionsAssignmentApi(payload) {
  return axios.request({
    method: "post",
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/employees/divisions-assignment/import/xlsx`,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    data: payload,
  })
}


function uploadTemplateCollaboratorsProgress(payload) {
  return axios.request({
    method: "get",
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/employees/import/xlsx/progress`,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    params: payload,
  })
}


function uploadTemplateDivisionsAssignmentProgressApi(payload) {
  return axios.request({
    method: "get",
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/employees/divisions-assignment/import/xlsx/progress`,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    params: payload,
  })
}

export function* uploadTemplateCollaboratorsWatcher(action) {
  try {
    yield call(messageProgress, "Cargando archivo")
    let data_response = yield call(uploadTemplateCollaborators, action.payload)
    setItem(KEY_TIMESTAMP_COLLABORATORS_IMPORT, data_response.data.timestamp)

    let data
    while (true) {
      yield new Promise((resolve) => setTimeout(resolve, 1000))

      data = yield call(uploadTemplateCollaboratorsProgress, {
        timestamp: data_response.data.timestamp,
      })

      if (data.status === 200) {
        break
      }
    }

    yield call(getCollaboratorsSummary)
    yield call(messageDestroy)
    yield call(messageSuccess, "Archivo importado")
    yield put(uploadTemplateCollaboratorsSuccess())
    yield put(push("/organization/collaborators/summary"))
  } catch (error) {
    yield put(uploadTemplateCollaboratorsFailed())
    yield call(messageDestroy)
    yield call(messageFailed, "Error al importar archivo")
  }
}



export function* uploadTemplateDivisionsAssignmentWatcher(action) {
  try {
    yield call(messageProgress, "Cargando archivo")
    let data_response = yield call(uploadTemplateDivisionsAssignmentApi, action.payload)
    setItem(KEY_TIMESTAMP_COLLABORATORS_IMPORT, data_response.data.timestamp)
    let data
    while (true) {
      yield new Promise((resolve) => setTimeout(resolve, 1000))

      data = yield call(uploadTemplateDivisionsAssignmentProgressApi, {
        timestamp: data_response.data.timestamp,
      })

      if (data.status === 200) {
        break
      }
    }

    yield call(getDivisionsAssignmentSummary)
    yield call(messageDestroy)
    yield call(messageSuccess, "Archivo importado")
    yield put(uploadTemplateDivisionsAssignmentSuccess())
    yield put(push("/organization/collaborators/summary?screen=divisions-assignment"))
  } catch (error) {
    yield put(uploadTemplateDivisionsAssignmentFailed())
    yield call(messageDestroy)
    yield call(messageFailed, "Error al importar el archivo")
  }
}

export function* uploadTemplateTeamsWatcher(action) {
  try {
    yield call(messageProgress, "Cargando archivo")
    let data_response = yield call(uploadTemplateTeams, action.payload)
    setItem(KEY_TIMESTAMP_COLLABORATORS_IMPORT, data_response.data.timestamp)
    let data
    while (true) {
      yield new Promise((resolve) => setTimeout(resolve, 1000))

      data = yield call(uploadTemplateTeamsProgress, {
        timestamp: data_response.data.timestamp,
      })

      if (data.status === 200) {
        break
      }
    }
    yield call(getTeamsSummary)
    yield call(messageDestroy)
    yield call(messageSuccess, "Archivo importado")
    yield put(uploadTemplateTeamsSuccess())
    yield put(push("/organization/collaborators/summary"))
  } catch (error) {
    console.log(error)
    yield put(uploadTemplateTeamsFailed())
    yield call(messageDestroy)
    yield call(messageFailed, "Error al importar el archivo")
  }
}


// UPLOAD EXCEL TEAMS
function uploadTemplateTeams(payload) {
  return axios.request({
    method: "post",
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/teams/import/xlsx`,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    data: payload,
  })
}

function uploadTemplateTeamsProgress(payload) {
  return axios.request({
    method: "get",
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/teams/import/xlsx/progress`,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    params: payload,
  })
}

// SAVE EXCEL
function saveExcelCollaboratorsApi() {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/employees/import/xlsx/confirm`,
    params: {
      timestamp: LOCAL_TIMESTAMP_COLLABORATORS_IMPORT(),
    },
  })
}

function saveExcelDivisionsAssignmentApi() {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/employees/divisions-assignment/import/xlsx/confirm`,
    params: {
      timestamp: LOCAL_TIMESTAMP_COLLABORATORS_IMPORT(),
    },
  })
}

function saveExcelCollaboratorsProgressApi() {
  return axios.request({
    method: "get",
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/employees/import/xlsx/confirm/progress`,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    params: {
      timestamp: LOCAL_TIMESTAMP_COLLABORATORS_IMPORT(),
    },
  })
}

function saveExcelDivisionsAssignmentProgressApi() {
  return axios.request({
    method: "get",
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/employees/divisions-assignment/import/xlsx/confirm/progress`,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    params: {
      timestamp: LOCAL_TIMESTAMP_COLLABORATORS_IMPORT(),
    },
  })
}

export function* saveExcelCollaboratorsSaga(action) {
  try {
    yield call(saveExcelCollaboratorsApi)
    let data
    while (true) {
      yield new Promise((resolve) => setTimeout(resolve, 200))
      data = yield call(saveExcelCollaboratorsProgressApi)
      yield put(saveExcelCollaboratorsProgress(data.data[0].percentage))
      if (data.status === 200) {
        yield put(saveExcelCollaboratorsSuccess(data))
        importCollaboratorSegment(
          "Colaboradores cargados exitosamente",
          "importSuccessEmployee",
          action.payload
        )
        break
      }
    }
  } catch (error) {
    console.log(error,error?.response?.status)
     if (error?.response?.status === 409) {
      const errorMessage = error.response.data?.error?.message ??
          "Ya existe una importación en curso para esta empresa."
      yield call(messageDestroy)
      yield call(messageFailed, errorMessage)
      yield put(saveExcelCollaboratorsFailed())
      importCollaboratorSegment(
        errorMessage,
        "importFailedEmployee",
        action.payload
      )
      return
    }
    const response = JSON.parse(JSON.stringify(error))
    yield call(messageDestroy)
    yield call(messageFailed, "Error al guardar los colaboradores")
    yield put(saveExcelCollaboratorsFailed())
    importCollaboratorSegment(
      "Save Template Error!",
      "importSuccessEmployee",
      action.payload.params
    )
  }
}


export function* saveExcelDivisionsAssignmentSaga(action) {
  try {
    yield call(saveExcelDivisionsAssignmentApi)
    let data
    while (true) {
      yield new Promise((resolve) => setTimeout(resolve, 200))
      data = yield call(saveExcelDivisionsAssignmentProgressApi)
      yield put(saveExcelDivisionsAssignmentProgress(data.data[0].percentage))
      if (data.status === 200) {
        yield put(saveExcelDivisionsAssignmentSuccess(data))
        
        break
      }
    }
  } catch (error) {
    setItem(KEY_TIMESTAMP_COLLABORATORS_IMPORT, null)
    console.log(error)
  }
}

// GET SUMMARY CEASED
function getCollaboratorsCeasedApi() {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/employees/cease/import/xlsx/summary`,
  })
}

function* getCollaboratorsCeasedSaga(action) {
  try {
    const { data, status } = yield call(getCollaboratorsCeasedApi)

    if (status === 200) {
      yield put(getCeasedSummarySuccess(data))
    }
  } catch (error) {
    yield put(getCeasedSummaryFailed())
    yield put(push("/organization"))
  }
}

// UPLOAD EXCEL CEASED
function uploadTemplateCeased(payload) {
  return axios.request({
    method: "post",
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/employees/cease/import/xlsx`,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    data: payload,
  })
}

function uploadTemplateCeasedProgress(payload) {
  return axios.request({
    method: "get",
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/employees/cease/import/xlsx/progress`,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    params: payload,
  })
}

export function* uploadTemplateCeasedWatcher(action) {
  try {
    yield call(messageProgress, "Cargando archivo")
    yield call(uploadTemplateCeased, action.payload)

    let data
    while (true) {
      yield new Promise((resolve) => setTimeout(resolve, 1000))

      data = yield call(uploadTemplateCeasedProgress)

      if (data.status === 200) {
        break
      }
    }

    yield call(messageDestroy)
    yield call(getCollaboratorsCeasedSaga)
    yield call(messageSuccess, "Archivo importado")
    yield put(uploadTemplateCeasedSuccess())
    yield put(push("/organization/collaborators/summary?screen=ceased"))
  } catch (error) {
    yield put(uploadTemplateCeasedFailed())
    yield call(messageDestroy)
    yield call(messageFailed, "Error al importar archivo")
  }
}

// SAVE EXCEL CEASED
function saveExcelCollaboratorsCeasedApi() {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/employees/cease/import/xlsx/confirm`,
  })
}

function saveExcelCollaboratorsCeasedProgressApi() {
  return axios.request({
    method: "get",
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/employees/cease/import/xlsx/confirm/progress`,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
  })
}

export function* saveCollaboratorsCeasedSaga(action) {
  try {
    yield call(saveExcelCollaboratorsCeasedApi)
    let data
    while (true) {
      yield new Promise((resolve) => setTimeout(resolve, 200))

      data = yield call(saveExcelCollaboratorsCeasedProgressApi)
      yield put(saveCollaboratorsCeasedProgress(data.data[0].percentage))
      if (data.status === 200) {
        importCollaboratorSegment(
          "Colaboradores cesados cargados exitosamente",
          "importCeasedEmployee",
          action.payload
        )
        yield put(saveCollaboratorsCeasedSuccess(data))
        break
      }
    }
  } catch (error) {
    importCollaboratorSegment(
      "Colaboradores cesados no cargados , error",
      "importCeasedEmployee",
      action.payload
    )
    const {
      response,
      response: { data },
    } = JSON.parse(JSON.stringify(error))
  }
}

// SAVE EXCEL TEAMS
function saveExcelTeamsApi(params) {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/teams/import/xlsx/confirm`,
    params: {
      timestamp: LOCAL_TIMESTAMP_COLLABORATORS_IMPORT(),
    }
  })
}

function saveExcelTeamsProgressApi() {
  return axios.request({
    method: "get",
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/teams/import/xlsx/confirm/progress`,
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    params: {
      timestamp: LOCAL_TIMESTAMP_COLLABORATORS_IMPORT(),
    }
  })
}

export function* saveTeamsSaga(action) {
  try {
    yield call(saveExcelTeamsApi)
    let data
    while (true) {
      yield new Promise((resolve) => setTimeout(resolve, 200))
      data = yield call(saveExcelTeamsProgressApi)
      yield put(saveTeamsProgress(data.data[0].percentage))
      if (data.status === 200) {
        yield put(saveTeamsSuccess(data))
        break
      }
    }
  } catch (error) {
    console.log(error)
    const {
      response,
      response: { data },
    } = JSON.parse(JSON.stringify(error))
  }
}



export default function* getDivisionWatcherSaga() {
  yield takeLatest(SAVE_EXCEL_CEASED_WATCHER, saveCollaboratorsCeasedSaga)
  yield takeLatest(SAVE_EXCEL_TEAMS_WATCHER, saveTeamsSaga)
  yield takeLatest(SAVE_EXCEL_COLLABORATORS_WATCHER, saveExcelCollaboratorsSaga)
  yield takeLatest(SAVE_EXCEL_DIVISIONS_ASSIGNMENT_WATCHER, saveExcelDivisionsAssignmentSaga)
  yield takeLatest(UPLOAD_TEMPLATE_CEASED_WATCHER, uploadTemplateCeasedWatcher)
  yield takeLatest(UPLOAD_TEMPLATE_DIVISIONS_ASSIGNMENT_WATCHER, uploadTemplateDivisionsAssignmentWatcher)
  yield takeLatest(UPLOAD_TEMPLATE_COLLABORATORS_WATCHER, uploadTemplateCollaboratorsWatcher)
  yield takeLatest(GET_CEASED_SUMMARY_WATCHER, getCollaboratorsCeasedSaga)
  yield takeLatest(GET_COLLABORATORS_SUMMARY_WATCHER, getCollaboratorsSummary)
  yield takeLatest(GET_DIVISIONS_ASSIGNMENT_SUMMARY_WATCHER, getDivisionsAssignmentSummary)
  yield takeLatest(GET_TEAMS_SUMMARY_WATCHER, getTeamsSummary)
}
